export default __webpack_public_path__ + "static/media/clouds.f74aa487.jpg";